
























import { Component, Vue } from "vue-property-decorator";
import md5 from "js-md5";
import { settlementOperation } from "@/req/settlement";
@Component({
  components: {},
})
export default class Home extends Vue {
  public modelShow = false;
  public state = 0;
  public show(state) {
    this.state = state;
    this.modelShow = true;
  }
  public async submit() {
    const obj = {
      type: this.state,
      token: this.$fn.cookies.getToken("token"),
    };
    const url = this.$HTTP_API.settlement.exportCsv;
    const param = Object.keys(obj);
    const data = Object.values(obj);
    let sign = "";
    param.map((item, index) => {
      const val = data[index] == undefined ? "" : data[index];
      sign += `${item}=${val}` + (index == param.length - 1 ? "" : "&");
    });
    const windowUrl = `${url}?${sign}&sign=${md5(sign)}`;
    this.modelShow = false;
    window.open(windowUrl);
  }
}
